<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>服务器管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="平台">
          <el-select
            v-model="query.platform"
            filterable
            clearable
            @change="getList()"
          >
            <el-option
              v-for="item in platList"
              :label="item"
              :value="item"
              :key="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业">
          <el-select
            v-model="query.companyID"
            filterable
            clearable
            @change="getList()"
          >
            <el-option
              v-for="item in accompany"
              :label="item.shortName"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getList()">查询</el-button>
          <el-button type="success" @click="dialogVisible = true"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>服务器记录列表</span>
        </div>
        <el-tabs v-model="query.state" @tab-click="selList()">
          <el-tab-pane :label="item.name" :key="item.id" :name="item.id.toString()" v-for="item in stateList"></el-tab-pane>
        </el-tabs>
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width: 100%"
        >
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="ip" label="IP地址"></el-table-column>
          
          <el-table-column prop="typeName" label="类型"></el-table-column>
          <el-table-column
            prop="companyName"
            label="所属企业"
          ></el-table-column>
          <el-table-column prop="platform" label="所属平台"></el-table-column>
          <el-table-column prop="setting" label="配置"></el-table-column>
          <el-table-column label="到期时间">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.isEndTime ? 'red' : '' }">{{
                scope.row.endTime
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="summary" label="备注"></el-table-column>
          <el-table-column prop="stateName" label="合作状态"></el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip content="编辑" placement="top">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  @click="editClick(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="查看" placement="top">
                <el-button
                  type="success"
                  size="mini"
                  icon="el-icon-view"
                  @click="viewClick(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <el-dialog
      :title="form.id > 0 ? '编辑服务器信息' : '添加服务器信息'"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-form-item
          label="服务器名称"
          prop="name"
          :rules="[{ required: true, message: '请输入服务器名称' }]"
        >
          <el-input
            v-model="form.name"
            placeholder="请输入服务器名称"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="IP地址"
          prop="ip"
          :rules="[{ required: true, message: '请输入IP地址' }]"
        >
          <el-input v-model="form.ip" placeholder="请输入IP地址"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="类型"
              prop="type"
              :rules="[{ required: true, message: '请输入服务器类型' }]"
            >
              <el-select v-model="form.type" filterable>
                <el-option
                  v-for="item in typeList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item
          label="所属平台"
          prop="platform"
          :rules="[{ required: true, message: '请输入所属平台' }]"
        >
          <el-input v-model="form.platform"></el-input>
        </el-form-item>

        <el-form-item
          label="配置"
          prop="setting"
          :rules="[{ required: true, message: '请输入I' }]"
        >
          <el-input v-model="form.setting" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item
          v-if="!(form.id > 0)"
          label="登录密码"
          prop="pwd"
          :rules="[{ required: true, message: '请输入所属平台' }]"
        >
          <el-input v-model="form.pwd"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="合作状态"
              prop="state"
              :rules="[{ required: true, message: '请选择状态' }]"
            >
              <el-select v-model="form.state" filterable>
                <el-option
                  v-for="item in stateList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所属企业" prop="companyname">
              <el-select v-model="form.companyID" filterable>
                <el-option
                  v-for="item in reverseCompany"
                  :label="item.shortName"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="到期时间" prop="endTime">
          <el-date-picker
      v-model="form.endTime"
      type="date"
      value-format='yyyy-MM-dd'
      placeholder="选择日期">
    </el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="summary">
          <el-input v-model="form.summary"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit"
            >提交</el-button
          >
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 查看对话框 -->
    <el-dialog :visible.sync="dialogView">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitView('form')"
      >
        <el-form-item
          label="操作密码"
          prop="pass"
          :rules="[{ required: true, message: '不能为空' }]"
        >
          <el-input v-model="form.pass" type="password"></el-input>
        </el-form-item>
        <el-form-item label="远程登录密码" v-if="form.removePwd">
          <el-input v-model="form.removePwd" type="text"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit"
            >提交</el-button
          >
          <el-button @click="dialogView = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      key: "",
      accompany: [], //企业列表
      query: {
        state:'1'
      }, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      dialogView: false,
      submiting: false,
      id: 0,
      stateList: [
        {
          id: 1,
          name: "使用中",
        },
        {
          id: 2,
          name: "已关闭",
        },
        {
          id: -1,
          name: "已放弃",
        },
      ],
      typeList: [
        {
          id: 1,
          name: "本公司",
        },
        {
          id: 2,
          name: "合作公司",
        },
        {
          id: 3,
          name: "个人",
        },
        {
          id: 4,
          name: "其他",
        },
      ],
      platList:['阿里云','腾讯云','华为云','天翼云','移动云']
    };
  },
      computed:{
    reverseCompany:function(){
      return this.accompany.slice(0).reverse();
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getAccInfo("getlist_server");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    //获取企业列表
    company: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getAccInfo("GetAll_Commany");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.accompany = data;
      });
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getAccInfo("addorupdate_server");
      var info = this.form;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑
    editClick: function (row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    // 查看
    viewClick: function (row) {
      this.form = Object.assign({}, row);
      this.dialogView = true;
    },
    submitView(formName) {
      var _this = this;
      var link = url.getAccInfo("viewpwd_server");
      var id = this.form.id;
      var operatePwd = this.form.pass;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, { id: id, operatePwd: operatePwd }, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
              _this.status = res.status;
              _this.form.removePwd = res.data;
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    //获取服务器列表
    this.getList();
    //获取企业列表
    this.company();
  },
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
</style>

